import React, { useEffect, useState } from "react";

import { Button, Card } from "react-bootstrap";

import "./custom.css";

export default function FileErrorTrends(props) {
  // const data=props.data

  const errors = props.errors;

  const warnings = props.warnings;

  let data = [...errors, ...warnings];

  let datalen = data.length;

  // const datalen = data.length;

  const [activeButton, setActiveButton] = useState("all");

  const handleButtonClick = (buttonId) => {
    setActiveButton(buttonId);
  };

  //1 is error 2 is warning

  //filter

  // const warnings = data.filter((item) => item.type === 'Warning');

  // const errors = data.filter((item) => item.type === 'Error');

  // let filteredData = data;

  if (activeButton === "warnings") {
    data = warnings;
  } else if (activeButton === "errors") {
    data = errors;
  }

  return (
    <div className="trends">
      <h2>Trends</h2>

      <div className="buttons">
        <Button
          onClick={() => handleButtonClick("all")}
          className={`btn ${activeButton === "all" ? "btnActive" : ""} `}
          variant="outline-primary"
        >
          All - <span>{datalen}</span>
        </Button>

        <Button
          onClick={() => handleButtonClick("errors")}
          className={`btn ${activeButton === "errors" ? "btnActive" : ""} `}
          variant="outline-primary"
        >
          Errors - <span>{errors.length}</span>
        </Button>

        <Button
          onClick={() => handleButtonClick("warnings")}
          className={`btn ${activeButton === "warnings" ? "btnActive" : ""} `}
          variant="outline-primary"
        >
          Warnings - <span>{warnings.length}</span>
        </Button>
      </div>

      {console.log(errors, warnings)}

      {data.map((item, index) => (
        <Card
          key={index}
          className={`card ${
            item.type === "Warning" ? "yellowish" : "reddish"
          }`}
        >
          <Card.Body className="cardmain">
            <div>
              <h4>{item.errorCodes}</h4>

              <p>{item.description}</p>
            </div>

            <div>
              <h5>{item.frequency}</h5>

              <p>Occurences</p>
            </div>
          </Card.Body>
        </Card>
      ))}
    </div>
  );
}
